enum Feedback {
  success,
  error,
  info,
  loading,
}

export default Feedback
